import { Pipe, type PipeTransform } from '@angular/core';
import { type MeasurementUnit } from '@api/devices';

import { MeasurementUnitShort } from '../models';

@Pipe({
  name: 'avsMeasurementUnitDisplay',
})
export class MeasurementUnitDisplayPipe implements PipeTransform {
  transform(measurementUnit: MeasurementUnit | undefined | null): string | null {
    const unit = measurementUnit?.displayShort;
    const hiddenUnits: string[] = [MeasurementUnitShort.YN, MeasurementUnitShort.COUNT];

    if (unit && !hiddenUnits.includes(unit)) {
      return unit;
    }

    return null;
  }
}
